module.exports = {
  "id": "grid_layout",
  "title": "grid layout",
  "color": "orange",
  "icon": "dotgrid",
  "category": "clone",
  "description": "Adjust sticker variables to arrange many clones of a piece on a grid.",
  "exposedVariables": [
    {
      "variableName": "# of columns",
      "spriteName": "$glitch_target",
      "tooltip":"Set the number of columns in the grid",
      "value": 4,
      "input": {
        "type": "slider",
        "min": 1,
        "max": 30,
        "step": 1,
        "onchange": "set-grid-layout-variable"
      }
    },
    {
      "variableName": "column width",
      "spriteName": "$glitch_target",
      "tooltip":"Set the width of each column in the grid",
      "value": 25,
      "input": {
        "type": "slider",
        "min": 1,
        "max": 100,
        "step": 1,
        "onchange": "set-grid-layout-variable"
      }
    },
    {
      "variableName": "# of rows",
      "spriteName": "$glitch_target",
      "tooltip":"Set the number of rows in the grid",
      "value": 4,
      "input": {
        "type": "slider",
        "min": 1,
        "max": 30,
        "step": 1,
        "onchange": "set-grid-layout-variable"
      }
    },
    {
      "variableName": "row height",
      "spriteName": "$glitch_target",
      "tooltip":"Set the height of each row in the grid",
      "value": 25,
      "input": {
        "type": "slider",
        "min": 1,
        "max": 100,
        "step": 1,
        "onchange": "set-grid-layout-variable"
      }
    }
  ],
  "info": [
    {
      "text": "Create many clones of a piece arranged in a grid",
      "image": "provision/glitches/grid_layout/grid_layout.gif"
    }
  ],
  "codeImage": "provision/glitches/grid_layout/grid_layout.png"
};